import React from "react";
import styles from "./ServiceBlock.module.scss";

interface Service {
  id: string;
  title: string;
  description: string;
}

const services: Service[] = [
  {
    id: "01",
    title: "Reparatur-Service",
    description:
      "Von komplexen Mechatronik-Reparaturen bis zur präzisen Programmierung der Steuergeräte – wir kümmern uns mit größter Sorgfalt um jedes Detail. Egal ob DSG-, S-Tronic- oder Powershift-Getriebe, ob Instandsetzung von Hydraulikblöcken oder Getriebesteuergeräten – unsere Spezialisten sorgen dafür, dass Ihr Auto wieder zuverlässig läuft.",
  },
  {
    id: "02",
    title: "Verkauf und Austausch",
    description:
      "Unser Austauschservice bietet Ihnen komplette Lösungen für DSG-, S-Tronic- und Powershift-Getriebe: von DQ200, DQ250, DQ380, DQ381, DQ400, DQ500 über DL382 und DL501 bis hin zu MPS6 und 6DCT-Modellen. Wir liefern geprüfte Mechatronik-Einheiten, Hydraulikblöcke und Getriebesteuergeräte – sofort einsatzbereit. Für besonders dringende Fälle steht Ihnen unser Express-Austausch zur Verfügung. So erhalten Sie schnell und zuverlässig die passende Einheit für Ihr Automatikgetriebe.",
  },
  {
    id: "03",
    title: "Wartung und Pflege",
    description:
      "Halten Sie Ihr Fahrzeug mit unserem präventiven Service in Topform. Wir bieten präzise Diagnosen sowie den fachgerechten Aus- und Einbau von DSG-, S-Tronic- und Powershift-Mechatroniken an. Dabei erfolgt stets ein professioneller Ölwechsel, um die Lebensdauer Ihres Automatikgetriebes zu sichern.",
  },
];

const ServiceBlock: React.FC = () => {
  return (
    <section id={styles.homeStatbg} className="staticSection brxeSection">
      <div className={`${styles.serviceMain}`}>
        <div className={styles.bgDarkOverlay}></div>
        <div className={styles.gradOverlayTop}></div>
        <div className={`${styles.serviceBlock} container sideP88`}>
          <div className={styles.leftBlock}></div>
          <div className={styles.rightBlock}>
            {services.map((service, index) => (
              <div
                key={service.id}
                className={`${styles.serviceItem} ${
                  index !== 0 ? "top12" : ""
                }`}
              >
                <p className={styles.idBlock}>{service.id}.</p>
                <div className={styles.infoDescription}>
                  <h5>{service.title}</h5>
                  <p className="textBasic">{service.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
        <div className={styles.gradOverlayBot}></div>
      </div>
    </section>
  );
};

export default ServiceBlock;
